import React from "react"

import './quote.scss'

export const CaseQuote = ( { author, text } ) => (
  <div className="case-quote">
    <q className="quote">{ text }</q>
    <span className="author">{ author }</span>
  </div>
)
